import useSWR from 'swr';
import { ReportStatus } from '../types';

export const useReportStatus = (clubSlug?: string | null, mandantId?: number | null) =>
    useSWR<{ data: ReportStatus }>(
        clubSlug && mandantId ? [`invoice/${clubSlug}/reports/status`, { mandant_id: mandantId }] : null
    );

export default useReportStatus;
